import React, { useState } from "react";
import { Link } from "gatsby";
import { categoryParams } from "../../../node-category";
import Europea from "../../assets/icons/europea.svg";

const Nav = ({ showMenu, closeMenu }) => {
  const [expandedIndex, setExpandedIndex] = useState(null);

  const toggleItem = (index) => {
    setExpandedIndex(newval => newval === index ? null : index);
  };

  // Menu principal, calqué sur l'arborescence du site FR (Tote Bags / Cabas / Pochettes /
  // Tote bags Français / Textiles / Fabrication spéciale), libellés ES.
  // Les entrées de 1er niveau ne sont que des étiquettes (hubs), elles ne pointent pas
  // vers une catégorie pour ne pas la cannibaliser.
  const links = [
    {
      url: `#`,
      label: "Totebags",
      items: [
        { url: `${categoryParams.urlPrefix}bolsas-personalizadas/`, label: "Totebags personalizadas" },
        { url: `${categoryParams.urlPrefix}bolsas-algodon-ecologico/`, label: "Totebags biológicos personalizados" },
        { url: `${categoryParams.urlPrefix}bolsas-gran-formato-personalizadas/`, label: "Totebags gran formato personalizadas" },
      ]
    },
    {
      url: `#`,
      label: "Bolsos",
      items: [
        { url: `${categoryParams.urlPrefix}bolsas-compra/`, label: "Bolsos de tela personalizadas" },
        { url: `${categoryParams.urlPrefix}bolsos-yute/`, label: "Bolsas de yute" },
        { url: `${categoryParams.urlPrefix}mochilas-cuerdas/`, label: "Mochila de cuerdas personalizadas" },
      ]
    },
    {
      url: `#`,
      label: "Sacos y accesorios",
      items: [
        { url: `${categoryParams.urlPrefix}sacos-tela-personalizados/`, label: "Sacos de tela personalizados" },
        { url: `${categoryParams.urlPrefix}neceser-personalizado/`, label: "Neceser personalizado" },
      ]
    },
    // Équivalent de « Tote bags Français » (FR), en attente : les sous-catégories
    // « fabricación europea » n'existent pas encore en base. Réactiver aussi l'icône
    // <Europea /> ci-dessous (équivalent de la barre tricolore FR).
    // {
    //   url: `#`,
    //   label: "Fabricación europea",
    //   items: [
    //     { url: `${categoryParams.urlPrefix}fabricacion-europea/`, label: "Totebags de fabricación europea" },
    //     { url: `${categoryParams.urlPrefix}bolsos-fabricacion-europea/`, label: "Bolsos de fabricación europea" },
    //     { url: `${categoryParams.urlPrefix}mochilas-fabricacion-europea/`, label: "Mochilas de fabricación europea" },
    //     { url: `${categoryParams.urlPrefix}neceser-fabricacion-europea/`, label: "Neceser de fabricación europea" },
    //   ]
    // },
    {
      url: `#`,
      label: "Ropa personalizada",
      items: [
        { url: `${categoryParams.urlPrefix}camisetas-personalizadas-hombre/`, label: "Camisetas personalizadas para hombre" },
        { url: `${categoryParams.urlPrefix}camisetas-personalizadas-mujer/`, label: "Camisetas personalizadas para mujer" },
        { url: `${categoryParams.urlPrefix}camisetas-personalizadas-ninos/`, label: "Camisetas personalizadas para niños" },
        { url: `${categoryParams.urlPrefix}gorras-personalizadas/`, label: "Gorras personalizadas" },
      ]
    },
    {
      url: `/fabricacion-a-medida`,
      label: "Fabricación a medida",
    },
  ];

  return <nav id="main-nav" className={`flex px-0 ${showMenu ? 'showMenu' : 'hidden'} `}>
    <ul className="flex space-x-2 space-y-8 lg:space-y-0 lg:justify-between items-center">
      <li className="lg:hidden w-full flex justify-start items-center py-4 absolute top-0 left-4">
        <button type="button" className="bg-transparent border-2 border-white rounded-full w-12 h-12 text-white font-bold text-xl flex items-center justify-center hover:bg-white hover:text-blue transition-colors" onClick={closeMenu}>X</button>
      </li>
      <li className="lg:hidden w-full text-center mt-4">
        <Link
          to="/contacto-el-taller-del-tote-bag"
          onClick={closeMenu}
          className="inline-block bg-blue-hover text-white rounded-md font-bold uppercase text-sm px-6 py-3 hover:bg-blue-light transition-colors"
        >
          Pide presupuesto
        </Link>
      </li>
      {links.map((link, i) => (
        <li key={i} className="w-full lg:w-auto">
          {link.items && (
            <div className="group relative flex flex-col">
              <span
                className="cursor-pointer flex items-center justify-center lg:justify-start relative"
              >
                {/* {link.label === "Fabricación europea" && <Europea />} */}
                {link.label}
                <span className="lg:hidden ml-2 text-xl">{expandedIndex === i ? '−' : '+'}</span>
                <span
                  onClick={() => toggleItem(i)}
                  className="absolute top-0 left-0 w-full h-full cursor-pointer"
                >&nbsp;</span>
              </span>
              <ul
                className={`lg:hidden lg:group-hover:block subMenu top-5 transition-all duration-300 overflow-hidden ${expandedIndex === i ? '' : 'max-h-0 opacity-0'} lg:group-hover:max-h-96 lg:group-hover:opacity-100`}
              >
                {link.items.map((item, j) => (
                  <li key={j} className="group/item">
                    <Link className="lg:group-hover/item:text-white" onClick={closeMenu} to={item.url}>{item.label}</Link>
                  </li>
                ))}
              </ul>
            </div>
          )}
          {!link.items && (
            <Link to={link.url} onClick={closeMenu} className="group relative flex flex-col">{link.label}</Link>
          )}

        </li>
      ))}

      <li className="hidden lg:block lg:ml-auto">
        <Link
          to="/contacto-el-taller-del-tote-bag"
          className="inline-block bg-orange !text-white !font-normal uppercase text-sm px-4 py-1 rounded-3xl hover:bg-gray-200 hover:!text-blue transition-colors mb-2"
        >
          Pide presupuesto
        </Link>
      </li>
    </ul>
  </nav>
};

export default Nav;
